import { Card } from 'antd';
import Button from 'antd/es/button';
import styled from 'styled-components';

export const ShareBenefitContainer = styled.div`
    display: flex;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
    flex-direction: column;
    align-items: center;
    gap: 32px;
    align-self: stretch;
`;

export const HeaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;
`;

export const BodyContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;
`;

export const StickerContainer = styled.div`
    display: flex;
    width: 160px;
    height: 160px;
    padding: 14.953px 34.064px 25.984px 34.072px;
    justify-content: center;
    align-items: center

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 12px;
    }
`;

export const ButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;
`;

export const TextContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    align-self: stretch;
`;

export const GreenText = styled.span`
    color: ${({ theme }) => theme.colors.theme.success};
    text-align: center;
    font-feature-settings: 'liga' off, 'clig' off;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
`;

export const NormalText = styled.span`
    color: ${({ theme }) => theme.colors.text.headings};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%;
`;

export const BoldText = styled.span`
    color: ${({ theme }) => theme.colors.text.headings};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%;
`;

export const EmailButton = styled(Button)`
    display: flex;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 32px;
    background: ${({ theme }) => theme.colors.theme.brandColor3} !important;
    color: ${({ theme }) => theme.colors.common.white} !important;
    border: none !important;
    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);
`;

export const WhatsappButton = styled(Button)`
    display: flex;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 32px;
    background: ${({ theme }) => theme.colors.theme.success} !important;
    color: ${({ theme }) => theme.colors.common.white} !important;
    border: none !important;
    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);
`;

export const DividerContainer = styled.div`
    display: flex;
    height: 15px;
    align-items: center;
    gap: 8px;
    align-self: stretch;
`;

export const StyledDivider = styled.div`
    height: 1px;
    flex: 1 0 0;
    border-bottom: 2px solid ${({ theme }) => theme.colors.text.muted};
`;

export const DividerText = styled(NormalText)`
    color: ${({ theme }) => theme.colors.text.muted};
`;

export const CopyLinkButton = styled(Button)`
    display: flex;
    height: 44px;
    padding: 10px 24px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    background: transparent;
    color: ${({ theme }) => theme.colors.theme.brandColor3} !important;
    border: none;
`;

export const QRContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    padding: 24px;
    border-radius: 16px;
    width: 100%;
    max-width: 300px;
`;

export const StyledQRCode = styled.img`
    width: 220px;
    height: 220px;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

export const DownloadButton = styled(Button)`
    display: flex;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 32px;
    background: ${({ theme }) => theme.colors.theme.brandColor3} !important;
    box-shadow: 0px 2px 1px 0px rgba(0, 0, 0, 0.20);

    &:hover {
        background: ${({ theme }) => theme.colors.theme.brandColor3} !important;
        color: ${({ theme }) => theme.colors.common.white} !important;
    }

    &:active {
        background: ${({ theme }) => theme.colors.theme.brandColor2} !important;
        color: ${({ theme }) => theme.colors.common.white} !important;
    }

    &:focus {
        background: ${({ theme }) => theme.colors.theme.brandColor3} !important;
    }
`;

export const StyledCard = styled(Card)`
    width: fit-content;
    gap: 10px;
    height: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background: white;
    font-size: 24px;
    font-weight: bold;
    background-color: white;
    color: black;
    text-align: center;
    padding: 8px;
`;